(() => {
  function init() {
    const root = document.querySelector('main');
    if (!root) return;
    const controls = root.querySelector('.jdr-filters');
    if (!controls || controls.dataset.ready) return;
    controls.dataset.ready = 'true';
    if (controls.jdrController) controls.jdrController.abort();
    const controller = new AbortController();
    controls.jdrController = controller;
    const category = controls.querySelector('[data-jdr-category]');
    const year = controls.querySelector('[data-jdr-year-filter]');
    const more = controls.querySelector('[data-jdr-more]');
    const count = controls.querySelector('[data-jdr-count]');
    const groups = [...root.querySelectorAll('.jdr-archive-year')];
    const records = groups.flatMap(group => [...group.querySelectorAll('[data-jdr-record]')].map(element => ({element, year: group.dataset.jdrYear})));
    let expanded = false;
    groups.forEach(group => { const option = document.createElement('option'); option.value = group.dataset.jdrYear; option.textContent = group.dataset.jdrYear; year.append(option); });
    function apply() {
      const matching = records.filter(record => (category.value === 'all' || record.element.dataset.category === category.value) && (year.value === 'all' || record.year === year.value));
      const visible = new Set((expanded ? matching : matching.slice(0, 12)).map(record => record.element));
      records.forEach(record => { record.element.hidden = !visible.has(record.element); });
      groups.forEach(group => {
        const hasVisible = [...group.querySelectorAll('[data-jdr-record]')].some(element => !element.hidden);
        // Keep the first group's filter controls visible even when its year has no results.
        if (group.contains(controls)) {
          group.hidden = false;
          group.querySelector('.jdr-year-heading').hidden = !hasVisible;
          group.querySelector('.jdr-archive').hidden = !hasVisible;
        } else group.hidden = !hasVisible;
      });
      count.textContent = matching.length ? `Showing ${visible.size} of ${matching.length} entries` : 'No entries match these filters.';
      // Keep focus on the expanded button so keyboard users retain their position.
      more.hidden = matching.length <= 12;
      more.setAttribute('aria-expanded', String(expanded));
      more.textContent = expanded ? 'Show latest entries' : 'View full archive';
    }
    category.addEventListener('change', () => { expanded = false; apply(); }, {signal: controller.signal});
    year.addEventListener('change', () => { expanded = false; apply(); }, {signal: controller.signal});
    more.addEventListener('click', () => { expanded = !expanded; apply(); }, {signal: controller.signal});
    controls.hidden = false;
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { const controls = document.querySelector('.jdr-filters'); if (controls) { controls.dataset.ready = ''; const year = controls.querySelector('[data-jdr-year-filter]'); while (year.options.length > 1) year.remove(1); } init(); });
})();
